import Link from "next/link";
import React from "react";
import footerData from "../../data/footer.json"; // Datos del footer en español
import FooterProps from "./FooterProps";

/**
 * Componente Footer que renderiza la información del pie de página.
 * Muestra secciones de enlaces, redes sociales y contactos, además del menú legal.
 *
 * @returns {JSX.Element} - Elemento de Footer.
 */
const Footer = () => {
  return (
    <>
      <footer className="rainbow-footer footer-style-default footer-style-3 position-relative">
        <div className="footer-top">
          <div className="container">
            <div className="row justify-content-between">
              {/** Sección de enlaces */}
              <div className="col-lg-3 col-md-6 col-sm-6 col-12">
                {footerData &&
                  footerData.footer.map((section, index) => (
                    <div className="rainbow-footer-widget" key={index}>
                      <FooterProps list={section.links} />
                    </div>
                  ))}
              </div>

              {/** Sección de redes sociales */}
              <div className="col-lg-3 col-md-6 col-sm-6 col-12">
                {footerData &&
                  footerData.footer.map((section, index) => (
                    <div className="rainbow-footer-widget" key={index}>
                      <FooterProps list={section.socialNetworks} />
                    </div>
                  ))}
              </div>

              {/** Sección de contactos */}
              <div className="col-lg-3 col-md-6 col-sm-6 col-12">
                {footerData &&
                  footerData.footer.map((section, index) => (
                    <div className="rainbow-footer-widget" key={index}>
                      <FooterProps list={section.contacts} />
                    </div>
                  ))}
              </div>
            </div>
          </div>
        </div>
      </footer>
      <div className="copyright-area copyright-style-one">
        <div className="container">
          <div className="row align-items-center">
            <div className="col-lg-8 col-md-8 col-sm-12 col-12">
              <div className="copyright-left">
                <ul className="ft-menu link-hover">
                  <li>
                    <Link href="/terminos-y-condiciones">
                      Términos y condiciones
                    </Link>
                  </li>
                  <li>
                    <Link href="/politica-de-devoluciones">
                      Politica de devoluciones
                    </Link>
                  </li>
                  <li>
                    <Link href="/contacto">Contacto</Link>
                  </li>
                  <li>
                    <Link href="/libro-de-reclamaciones">
                      Libro de reclamaciones
                    </Link>
                  </li>
                </ul>
              </div>
            </div>
            <div className="col-lg-4 col-md-4 col-sm-12 col-12">
              <div className="copyright-right text-center text-lg-end">
                <p className="copyright-text">
                  <i className="fa-regular fa-copyright"></i>{" "}
                  {new Date().getFullYear()} TutorIA+
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Footer;
